<template>
  <v-dialog
    v-model="agregarVehiculoDialog"
    width="40%"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="secondary"
        class="d-inline ml-4"
        v-bind="attrs"
        v-on="on"
        @click="agregarVehiculoDialog = true"
      >
        Agregar vehículo
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Nuevo vehículo
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="agregarVehiculoDialog = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="vehiculoForm"
        >
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="vehiculo.fk_idModeloVehiculo"
                  label="Modelo del vehículo"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="modelos"
                  item-value="id"
                  item-text="nombre"
                  :rules="nameRules"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="vehiculo.fk_idColorVehiculo"
                  label="Color del vehículo"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="colores"
                  item-value="id"
                  item-text="title"
                  :rules="nameRules"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="vehiculo.anio"
                  label="Año"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="vehiculo.placa"
                  label="Placa"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="vehiculo.seriemotor"
                  label="Número de serie del motor"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="vehiculo.serievehiculo"
                  label="Número de serie del vehículo"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="vehiculo.aseguradora"
                  label="Aseguradora"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                align="center"
              >
                <div class="text-subtitle2 font-weight-bold">
                  Fecha de adquisición
                </div>
                <v-date-picker
                  v-model="vehiculo.fechaAdquisicion"
                  locale="es"
                  color="secondary"
                  no-title
                  full-width
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="!vehiculoForm || loading"
          @click="triggerSaveVehiculo()"
        >
          Guardar vehículo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: {
    idPersonal: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      agregarVehiculoDialog: false,

      vehiculoForm: false,
      loading: false,
      vehiculo: {
        fk_idPersonal: this.idPersonal,
        fk_idModeloVehiculo: 0,
        fk_idColorVehiculo: 0,
        anio: null,
        placa: '',
        fechaAdquisicion: null,
        seriemotor: '',
        serievehiculo: '',
        aseguradora: '',
        fk_idTipo: 1,
        fk_idUso: 1,
      },

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('modelo', {
      modelos: 'getModelos',
    }),

    ...mapGetters('color', {
      colores: 'getColores',
    }),

    getMaxDay() {
      return moment().format('YYYY-MM-DD');
    },
  },

  async mounted() {
    await this.fetchModelos();
    await this.fetchColores();
  },

  methods: {
    ...mapActions('vehiculos', ['saveVehiculo', 'fetchVehiculos']),
    ...mapActions('modelo', ['fetchModelos']),
    ...mapActions('color', ['fetchColores']),

    async triggerSaveVehiculo() {
      this.loading = true;
      await this.saveVehiculo(this.vehiculo);

      this.closeDialog();
    },

    async closeDialog() {
      this.loading = false;
      this.vehiculo = {
        fk_idPersonal: this.idPersonal,
        fk_idModeloVehiculo: 0,
        fk_idColorVehiculo: 0,
        anio: null,
        placa: '',
        fechaAdquisicion: null,
        seriemotor: '',
        serievehiculo: '',
        aseguradora: '',
        fk_idTipo: 1,
        fk_idUso: 1,
      };
      this.agregarVehiculoDialog = false;
      this.$refs.form.resetValidation();
      await this.fetchVehiculos(this.idPersonal);
    },
  },
};
</script>
